export default __webpack_public_path__ + "static/media/cobrand-AMEX.0a5a4b43.svg";